//@ts-nocheck
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";
import { ApplicationState } from "../../store";

function ApiFailedError({ fromRegistration, fromApiError = false }: any) {
    const location = useLocation();
    const history = useHistory();

    const [isAccess, setIsAccess] = useState(true);
    const [isStartClick, setIsStartClick] = useState(false);
    const [isPopup, setIsPopup] = useState(false);
    const query = new URLSearchParams(location.search);
    const registerError = query.get("registrationError") === "true";

    const SSO_HANDLER = window.location.origin + "/app/.ssohandler";
    const ACCESS_REQUEST = window.location.origin + "/app/access-request";

    const partnerPhone = useSelector((state: ApplicationState) =>
        state.configurationState &&
            state.configurationState.configuration.partnerConfig.phoneNumber
            ? state.configurationState.configuration.partnerConfig.phoneNumber
            : "1-888-439-7443"
    );

    const isRegistrationError =
        history.location && history.location.state
            ? history.location.state.fromRegistration
            : false;

    function getCookie(name) {
        console.log("Checking cookie:", name);
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        const result = parts.length === 2 ? parts.pop().split(";").shift() : null;
        console.log("Cookie value:", result);
        return result;
    }

    const isSafari = /^((?!chrome|android).)*safari/i.test(
        window.navigator.userAgent
    );

    useEffect(() => {
        document.cookie = "dummyCookie=requestaccess";

        console.log("====================================");
        console.log("Initial Load Debug Info");
        console.log("====================================");

        console.log("Full URL:", window.location.href);
        console.log("Origin:", window.location.origin);
        console.log("Path:", window.location.pathname);

        console.log("UserAgent:", window.navigator.userAgent);
        console.log("Running inside iframe:", window.self !== window.top);
        console.log("Top equals self:", window.self === window.top);

        console.log("Safari detected:", isSafari);
        console.log("Cookies on load:", document.cookie);
        console.log("SessionStorage safariRetry:", sessionStorage.getItem("safariRetry"));

        console.log("hasStorageAccess supported:", typeof document.hasStorageAccess === "function");
        console.log("requestStorageAccess supported:", typeof document.requestStorageAccess === "function");

        if (typeof document.hasStorageAccess === "function") {
            document.hasStorageAccess()
                .then((hasAccess) => {
                    console.log("hasStorageAccess on load:", hasAccess);
                    console.log("Cookies after hasStorageAccess:", document.cookie);

                    setIsAccess(hasAccess);

                    if (hasAccess && fromRegistration) {
                        console.log("Access already granted → redirecting");
                        console.log("Redirect URL:", SSO_HANDLER);

                        sessionStorage.removeItem("safariRetry");
                        console.log("Retry counter cleared");

                        window.location.href = SSO_HANDLER;
                    }
                })
                .catch((err) => {
                    console.log("Error checking storage access:", err);
                });
        } else {
            console.log("hasStorageAccess API not supported");
        }
    }, [fromRegistration]);

    const getSafariVersion = () => {
        const match = navigator.userAgent.match(/Version\/(\d+)/);
        const version = match ? parseInt(match[1], 10) : null;
        console.log("Detected Safari Version:", version);
        return version;
    };

    const handleStorageRequest = () => {
        console.log("====================================");
        console.log("Continue Button Clicked");
        console.log("====================================");

        console.log("Current URL:", window.location.href);
        console.log("Cookies before request:", document.cookie);
        console.log("SessionStorage safariRetry before request:", sessionStorage.getItem("safariRetry"));

        const safariVersion = getSafariVersion();
        console.log("safariVersion", safariVersion);

        const isOldSafari = safariVersion && safariVersion < 26;
        console.log("Is old Safari (<26):", isOldSafari);

        if (typeof document.requestStorageAccess !== "function") {
            console.log("Storage Access API not supported");
            return;
        }

        console.log("Calling document.requestStorageAccess()");

        document
            .requestStorageAccess()
            .then(() => {
                console.log("Storage access granted");
                console.log("Cookies after access:", document.cookie);

                if (isOldSafari) {
                    console.log("Old safari detected");
                    console.log("Redirecting to SSO handler:", SSO_HANDLER);

                    window.location.href = SSO_HANDLER;
                } else {
                    console.log("New safari detected");

                    const retryCount = Number(
                        sessionStorage.getItem("safariRetry") || "0"
                    );

                    console.log("Current retry count:", retryCount);

                    if (retryCount < 2) {
                        const nextRetry = retryCount + 1;
                        console.log("Setting next retry count:", nextRetry);

                        sessionStorage.setItem("safariRetry", String(nextRetry));

                        const delay = 1000;
                        console.log(`Attempt ${nextRetry}: redirecting after ${delay}ms`);

                        setTimeout(() => {
                            console.log("Executing redirect now");
                            console.log("Final cookies before redirect:", document.cookie);
                            console.log("Retry counter before redirect:", sessionStorage.getItem("safariRetry"));

                            console.log("Redirecting to SSO handler:", SSO_HANDLER);
                            window.location.href = SSO_HANDLER;
                        }, delay);

                        return;
                    }

                    console.log("Max retries reached - showing fallback");

                    sessionStorage.removeItem("safariRetry");
                    setIsStartClick(true);
                }
            })
            .catch((err) => {
                console.log("Storage access denied:", err);
                console.log("Cookies at denial:", document.cookie);
                console.log("Retry counter at denial:", sessionStorage.getItem("safariRetry"));

                setTimeout(() => {
                    setIsStartClick(true);
                }, 300);

                if (!window.location.pathname.includes("access-request")) {
                    console.log("Redirecting to access request page:", ACCESS_REQUEST);
                    window.location.href = ACCESS_REQUEST;
                }
            });
    };

    useEffect(() => {
        const cookieValue = getCookie("embeddedCookie");
        const cookieElement = document.getElementById("cookieValue");

        console.log("Checking embeddedCookie:", cookieValue);
        console.log("All cookies visible:", document.cookie);

        if (cookieValue && cookieElement) {
            cookieElement.innerText = cookieValue;
        }
    }, []);

    const renderSafariMessage = () => {
        return isStartClick || isPopup ? (
            <div>
                <h3 className="error-page-title">
                    Access Identity Theft Protection
                </h3>
                <p>
                    To access Identity Theft Protection on your browser,
                    please allow the use of cookies. This information is
                    used only to display the features available in
                    Identity Theft Protection and keep your data secure.
                </p>
            </div>
        ) : (
            <div>
                <h3 className="error-page-title">
                    Welcome to Identity Theft Protection
                </h3>
                <p>
                    Best in class protection for your identity, powered by
                    IdentityForce™.
                </p>
            </div>
        );
    };

    const isSafariAccess = isSafari && fromRegistration;

    console.log("Render triggered");
    console.log("isSafariAccess:", isSafariAccess);
    console.log("isAccess state:", isAccess);
    console.log("fromRegistration:", fromRegistration);

    return (
        <div
            className={
                isSafariAccess
                    ? "box-description flex-center justify-center"
                    : "box-description mav-risk-not-found null-body-detected-breach"
            }
        >
            <div className="row row-container">
                <div className="col-sm-3"></div>

                <div className="col-xs-12 col-sm-12 text-align-center col-main">
                    <span className="fs-26">
                        {isSafariAccess ? null : (
                            <RenderIcons iconName="info-circle" />
                        )}
                    </span>

                    {isSafariAccess ? (
                        renderSafariMessage()
                    ) : (
                        <div>
                            <div className="title-main mtb-1rem">
                                {isRegistrationError ||
                                    registerError ||
                                    fromApiError ? (
                                    "Sorry, we are unable to retrieve details at this time."
                                ) : (
                                    <div>
                                        {
                                            "We use cookies to provide you the best experience and services. To continue, please enable them in your browser settings. Go to Privacy > Cookies, and allow all cookies. If you’ve done this and still experience issues, please try using a different browser or call"
                                        }
                                        <a
                                            className="pd-left-3"
                                            href={'tel:"' + partnerPhone + '"'}
                                        >
                                            {partnerPhone}
                                        </a>
                                        .
                                    </div>
                                )}
                            </div>

                            {(isRegistrationError ||
                                registerError ||
                                fromApiError) && (
                                    <div className="description">
                                        Please call{" "}
                                        <a
                                            className="pd-right-3"
                                            href={'tel:"' + partnerPhone + '"'}
                                        >
                                            {partnerPhone}
                                        </a>{" "}
                                        if you are still experiencing issues
                                        with our site.
                                    </div>
                                )}
                        </div>
                    )}
                </div>

                {isSafariAccess ? (
                    <div className="col-xs-12 justify-center text-align-center col-main pt-2">
                        <button
                            type="button"
                            onClick={handleStorageRequest}
                            className="btn-default btn-primary btn-min-width"
                        >
                            <span className="btn-text">
                                {isStartClick || isPopup
                                    ? "Continue and allow cookies"
                                    : "Continue"}
                            </span>
                        </button>
                    </div>
                ) : (
                    <div className="col-sm-3"></div>
                )}
            </div>
        </div>
    );
}

export default ApiFailedError;
